export const ANALYTICS_EVENTS = {
    AUTH: {
      USER_IDENTIFIED: 'User Identified',
      USER_LOGGED_OUT: 'User Logged Out',
    },
    MIXPANEL: {
      ENV_INSTANCE: 'envInstance',
      EXPERIMENT_INSTANCE: 'experimentInstance',
    },
  
    JOBS_LIBRARY: {
      COMPARE_JDS_FROM_JOB_LISTING: 'Compare Job Descriptions from job listing',
      COMPARE_JDS: 'Compare Job Descriptions',
      JD_STATUS_FILTER: 'JD Status Filter',
      SEARCH_SELECTED_JDS: 'Search Selected JDs',
      SEARCH_JDS: 'Search JDs',
      CHANGE_TOGGLE: 'Change Toggle',
      TOGGLE_FILTER: 'Toggle Filter',
      CREATE_JD: 'Create JD',
      CREATE_JD_SUBMIT: 'Create JD Submit',
      REVISE_JD_SUBMIT: 'Revise JD Submit',
      CLEAR_ALL_FILTERS: 'Clear All Filters',
      CREATE_JD_DRAWER_CLOSE: 'Create JD Drawer Close',
      CLOSE_DRAWER: 'Close Drawer',

      JOB_DETAILS: {
        DIFFERENCE_CHECKER: 'Difference Checker',
        COMPARE_JDS_FROM_JOB_DETAILS: 'Compare Job Descriptions form job details',
        EDIT_JD: 'Edit JD',
        REVISE_JD: 'Revise JD',
        DOWNLOAD_JD: 'Download JD',
        SUBMIT_FOR_APPROVAL: 'Submit for Approval',
        UNPUBLISH_JD: 'Unpublish JD',
        DOWNLOAD_PDF: 'Download PDF',
        DOWNLOAD_DOCX: 'Download DOCX',
        VERSION_CHANGE: 'Version Change',
        SELECTED_JD_TAB: 'Selected JD Tab',
        SAVE_CLICK: 'Save Click',
        APPROVED_JD: 'Approved JD',
        APPROVER_SUBMIT_JD: 'Approver Submit JD',
        CLOSE_JOB_DETAILS_PAGE: 'Close job details page',
        CUSTOM_COMPARE: 'Custom Compare',
        COMPARE_JOBS: 'Compare Jobs from Compare Job Descriptions',
        COMPARE_JOBS_DIFFERENCE_CHECKER: 'Compare Jobs difference checker from Compare Job Descriptions',
        COMPARE_MARKDOWN: 'Compare Markdown from Compare Job Descriptions',
        REVISE_JD_DRAWER_CLOSE: 'Revise JD Drawer Close',
      }
    },

    PEOPLE_PLUS_AI: {
      // Main landing page
      REFRESH_DATA: 'PAIC Refresh Data',
      SEARCH_ROLES: 'PAIC Search Roles',
      FILTER_ROLES: 'PAIC Filter Roles',
      CLEAR_FILTERS: 'PAIC Clear Filters',
      CREATE_GROUP: 'PAIC Create Group',
      SELECT_GROUP: 'PAIC Select Group',
      EVALUATE_PAIC_INITIATED: 'PAIC Evaluate Initiated',
      RE_EVALUATE_PAIC_INITIATED: 'PAIC Re-Evaluate Initiated',
      VIEW_PAIC_POTENTIAL: 'PAIC View Potential',
      PAGINATION_CHANGE: 'PAIC Pagination Change',

      // Group Agents View
      BACK_TO_MAIN: 'PAIC Back to Main',
      VIEW_BY_TOGGLE: 'PAIC View By Toggle',
      SELECT_AGENT: 'PAIC Select Agent',
      DESELECT_AGENT: 'PAIC Deselect Agent',
      SELECT_ALL_AGENTS: 'PAIC Select All Agents',
      SUBMIT_AGENTS: 'PAIC Submit Selected Agents',
      VERSION_SELECTED: 'PAIC Version Selected',
      DOCUMENT_TYPE_SELECTED: 'PAIC Document Type Selected',
      SORT_AGENTS: 'PAIC Sort Agents',
      SORT_ROLES: 'PAIC Sort Roles',
      AGENT_ROW_CLICKED: 'PAIC Agent Row Clicked',
      ROLE_ROW_CLICKED: 'PAIC Role Row Clicked',
      TAB_CHANGED: 'PAIC Tab Changed',

      // Agent Details
      AGENT_DETAILS_VIEWED: 'PAIC Agent Details Viewed',
      EDIT_AGENT_NAME: 'PAIC Edit Agent Name',
      SAVE_AGENT_NAME: 'PAIC Save Agent Name',
      CANCEL_AGENT_NAME_EDIT: 'PAIC Cancel Agent Name Edit',
      EDIT_AGENT_DESCRIPTION: 'PAIC Edit Agent Description',
      SAVE_AGENT_DESCRIPTION: 'PAIC Save Agent Description',
      CANCEL_AGENT_DESCRIPTION_EDIT: 'PAIC Cancel Agent Description Edit',
      EXPAND_ROLE_DETAIL: 'PAIC Expand Role Detail',
      COLLAPSE_ROLE_DETAIL: 'PAIC Collapse Role Detail',

      // Role Impact
      ROLE_IMPACT_VIEWED: 'PAIC Role Impact Viewed',
      VIEW_MORE_ROLE_IMPACT: 'PAIC View More Role Impact',
      
      // Role Impact Details
      ROLE_IMPACT_DETAILS_VIEWED: 'PAIC Role Impact Details Viewed',
      EXPAND_TASK_WORKFLOW: 'PAIC Expand Task Workflow',
      COLLAPSE_TASK_WORKFLOW: 'PAIC Collapse Task Workflow',

      // Documents
      JD_PRD_VIEW_OPENED: 'PAIC JD/PRD View Opened',
      JD_PRD_EDIT_MODE: 'PAIC JD/PRD Edit Mode',
      JD_PRD_SAVE: 'PAIC JD/PRD Save',
      JD_PRD_CANCEL: 'PAIC JD/PRD Cancel',
      JD_PRD_PAGINATION: 'PAIC JD/PRD Pagination',
      PEOPLE_JD_VIEW_OPENED: 'PAIC People JD View Opened',
      PEOPLE_JD_EDIT_MODE: 'PAIC People JD Edit Mode',
      PEOPLE_JD_SAVE: 'PAIC People JD Save',
      PEOPLE_JD_CANCEL: 'PAIC People JD Cancel',
      PEOPLE_JD_PAGINATION: 'PAIC People JD Pagination',

      // Close actions
      CLOSE_AGENT_DETAILS: 'PAIC Close Agent Details',
      CLOSE_ROLE_IMPACT: 'PAIC Close Role Impact',
      CLOSE_ROLE_IMPACT_DETAILS: 'PAIC Close Role Impact Details',
      CLOSE_DOCUMENTS: 'PAIC Close Documents',

      // Dashboard / Agent Library (V2). The names above this line are fired
      // from PAIC V2 screens; these were only ever fired from the V1 landing
      // page, which RouteConfigV2 no longer renders.
      AGENT_LIBRARY_VIEWED: 'PAIC Agent Library Viewed',
    },

    // Blocks below are new. They follow the '<Module> <Action>' shape that
    // PEOPLE_PLUS_AI already uses, so the prefix is universal rather than
    // optional. Properties stay the same as everywhere else in this file:
    // from / email / description plus ids, titles and counts. Deliberately no
    // compensation, salary or budget VALUES — no existing module sends money,
    // and Org Design is the first module that could.

    ORG_DESIGN: {
      // Landing
      LANDING_VIEWED: 'Org Design Landing Viewed',
      START_FROM_CURRENT_ORG: 'Org Design Start From Current Org',
      OPEN_PAIC_IMPORT: 'Org Design Open PAIC Import',
      VERSION_OPENED: 'Org Design Version Opened',
      VERSION_ARCHIVED: 'Org Design Version Archived',
      ORG_CONTEXT_OPENED: 'Org Design Org Context Opened',

      // PAIC Recommended import wizard
      PAIC_GROUP_SELECTED: 'Org Design PAIC Group Selected',
      PAIC_VERSION_SELECTED: 'Org Design PAIC Version Selected',
      GENERATE_INITIATED: 'Org Design Generate Initiated',
      GENERATE_COMPLETED: 'Org Design Generate Completed',
      GENERATE_PENDING: 'Org Design Generate Still Running',
      GENERATE_STATUS_CHECKED: 'Org Design Generate Status Checked',
      REGENERATE: 'Org Design Regenerate',
      OPEN_IN_WORKSPACE: 'Org Design Open In Workspace',

      // Workspace
      VIEW_TOGGLED: 'Org Design View Toggled',
      LAYOUT_TOGGLED: 'Org Design Layout Toggled',
      TREES_EXPANSION_CHANGED: 'Org Design Trees Expand Or Collapse All',
      ROLE_HEADCOUNT_CHANGED: 'Org Design Role Headcount Changed',
      ROLE_STATUS_CHANGED: 'Org Design Role Status Changed',
      ROLE_REPARENTED: 'Org Design Role Reparented',
      ROLE_RENAMED: 'Org Design Role Renamed',
      PROPOSED_ROLE_ADDED: 'Org Design Proposed Role Added',
      PROPOSED_ROLE_REMOVED: 'Org Design Proposed Role Removed',
      TARGET_BUDGET_SET: 'Org Design Target Budget Set',
      VERSION_SAVED: 'Org Design Version Saved',
      DOWNLOAD_PDF: 'Org Design Download PDF',
      TREE_EXPORTED_PNG: 'Org Design Tree Exported PNG',
      TREE_FULLSCREEN_TOGGLED: 'Org Design Tree Fullscreen Toggled',
    },

    TALENT_MOBILITY: {
      MANAGER_DASHBOARD_VIEWED: 'Talent Mobility Manager Dashboard Viewed',
      ROLE_DETAIL_VIEWED: 'Talent Mobility Role Detail Viewed',
      SUCCESSION_PLANNING_VIEWED: 'Talent Mobility Succession Planning Viewed',
      REDEPLOYMENT_CENTER_VIEWED: 'Talent Mobility Redeployment Center Viewed',
      REDUCTION_DETAIL_VIEWED: 'Talent Mobility Reduction Detail Viewed',
      WORKFORCE_PLANNING_VIEWED: 'Talent Mobility Workforce Planning Viewed',
      VIEW_PLANNING_VIEWED: 'Talent Mobility View Planning Viewed',
      PAIC_ORG_REDESIGN_VIEWED: 'Talent Mobility PAIC Org Redesign Viewed',
      CANDIDATE_PROFILE_VIEWED: 'Talent Mobility Candidate Profile Viewed',
      EMPLOYEE_VIEW_OPENED: 'Talent Mobility Employee View Opened',
      OPPORTUNITY_VIEWED: 'Talent Mobility Opportunity Viewed',
    },

    SKILLS_BRIDGER: {
      DASHBOARD_VIEWED: 'Skills Bridger Dashboard Viewed',
      GROUP_PROFICIENCY_VIEWED: 'Skills Bridger Group Proficiency Viewed',
      SKILLS_MAP_VIEWED: 'Skills Bridger Skills Map Viewed',
      EMPLOYEE_VIEW_OPENED: 'Skills Bridger Employee View Opened',
    },

    ASK_ALLIE: {
      PANEL_OPENED: 'Ask Allie Panel Opened',
      PANEL_CLOSED: 'Ask Allie Panel Closed',
      PANEL_MODE_CHANGED: 'Ask Allie Panel Mode Changed',
      QUESTION_SUBMITTED: 'Ask Allie Question Submitted',
      RESPONSE_RECEIVED: 'Ask Allie Response Received',
      RESPONSE_FAILED: 'Ask Allie Response Failed',
      CHAT_CLEARED: 'Ask Allie Chat Cleared',
      FEEDBACK_SUBMITTED: 'Ask Allie Feedback Submitted',
    },

    LEARNING_CATALYST: {
      VIEWED: 'Learning Catalyst Viewed',
    },

    ADMIN_SETUP: {
      VIEWED: 'Admin Setup Viewed',
      JD_ARCHIVED: 'Admin Setup JD Archived',
    },
  };
  